export default __webpack_public_path__ + "static/costume_f_cape-1a53bff3d67749c24d3ea0de2e2bb92f.png";